import { createAsyncThunk } from '@reduxjs/toolkit';

import { putDailyList, getDailyListApproval, getSingleDailyListEntry, postDailyList, excludeDailyList, includeDailyList, postGlobalDailyList, getDailyListUnApproved, getDailyListExcluded, getPostedDailyList, getIsDLPosted, getDLStats, getIsDailyListPosted, postSearchDailyList, getInstrumentDocumentPaginatedData, getDailyListDocuments, getInstrumentsPendingApprovalCount, getInstrumentsPendingApproval } from './cruds';

export const ACTION_TYPE_PARENT = 'dailyList'

// NOTE: keep function name and thunk child name same
export const fetchDailyListApproval = createAsyncThunk(`${ACTION_TYPE_PARENT}/fetchDailyListApproval`,
  async (_, { rejectWithValue }) => {
    try {
      const response = await getDailyListApproval()
      return response.data;
    }
    catch (err: any) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue({ status: err.response.status, code: err.code, message: err.message })
    }
  }
)

export const fetchIsDLPosted = createAsyncThunk(`${ACTION_TYPE_PARENT}/fetchIsDLPosted`,
  async (_, { rejectWithValue }) => {
    try {
      const response = await getIsDLPosted()
      return response;
    }
    catch (err: any) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue({ status: err.response.status, code: err.code, message: err.response?.data ?? ''})
    }
  }
)

export const fetchDLStats = createAsyncThunk(`${ACTION_TYPE_PARENT}/fetchDLStats`,
  async (_, { rejectWithValue }) => {
    try {
      const response = await getDLStats()
      return response.data;
    }
    catch (err: any) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue({ status: err.response.status, code: err.code, message: err.message })
    }
  }
)

// NOTE: keep function name and thunk child name same
export const fetchDailyListUnApproved = createAsyncThunk(`${ACTION_TYPE_PARENT}/fetchDailyListUnApproved`,
  async (_, { rejectWithValue }) => {
    try {
      const response = await getDailyListUnApproved()
      return response.data;
    }
    catch (err: any) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue({ status: err.response.status, code: err.code, message: err.message })
    }
  }
)

export const fetchSingleDailyListEntry = createAsyncThunk(`${ACTION_TYPE_PARENT}/fetchSingleDailyListEntry`,
  async (symbol: string, { rejectWithValue }) => {
    try {
      const response = await getSingleDailyListEntry(symbol)
      return response.data;
    }
    catch (err: any) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue({ status: err.response.status, code: err.code, message: err.message })
    }
  }
)

export const fetchDailyListExcluded = createAsyncThunk(`${ACTION_TYPE_PARENT}/fetchDailyListExcluded`,
  async (_, { rejectWithValue }) => {
    try {
      const response = await getDailyListExcluded()
      return response.data;
    }
    catch (err: any) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue({ status: err.response.status, code: err.code, message: err.message })
    }
  }
)

export const fetchPostedDailyList = createAsyncThunk(`${ACTION_TYPE_PARENT}/fetchPostedDailyList`,
  async ({advanced, requestHeaders = undefined} : any, { rejectWithValue }) => {
    try {
      const response = await getPostedDailyList(advanced, requestHeaders)
      return response.data;
    }
    catch (err: any) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue({ status: err.response.status, code: err.code, message: err.message })
    }
  }
)

export const updateDailyList = createAsyncThunk(`${ACTION_TYPE_PARENT}/updateDailyList`,
  async ({ nsm, dlEntryComment, systemNoteComment }: any, { rejectWithValue }) => {
    try {
      const response = await putDailyList(nsm, dlEntryComment, systemNoteComment)
      return response.data;
    }
    catch (err: any) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue({ status: err.response.status, code: err.code, message: err?.response?.data })
    }
  }
)

export const createDailyList = createAsyncThunk(`${ACTION_TYPE_PARENT}/createDailyList`,
  async ({ nsm, dlEntryComment, systemNoteComment }: any, { rejectWithValue }) => {
    try {
      const response = await postDailyList(nsm, dlEntryComment, systemNoteComment)
      return response.data;
    }
    catch (err: any) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue({ status: err.response.status, code: err.code, message: err.response.data })
    }
  }
)


export const excludeFromDailyList = createAsyncThunk(`${ACTION_TYPE_PARENT}/excludeFromDailyList`,
  async ({ nsm }: any, { rejectWithValue }) => {
    try {
      const response = await excludeDailyList(nsm)
      return response.data;
    }
    catch (err: any) {
      if (!err.response) {
        throw err
      }
      
      return rejectWithValue({ status: err.response.status, code: err.code, message: err.response?.data })
    }
  }
)

export const includeInDailyList = createAsyncThunk(`${ACTION_TYPE_PARENT}/includeInDailyList`,
  async ({ nsm }: any, { rejectWithValue }) => {
    try {
      const response = await includeDailyList(nsm)
      return response.data;
    }
    catch (err: any) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue({ status: err.response.status, code: err.code, message: err.message })
    }
  }
)

export const submitGlobalDailyList = createAsyncThunk(`${ACTION_TYPE_PARENT}/submitGlobalDailyList`,
  async ({ systemNote }: any, { rejectWithValue }) => {
    try {
      const response = await postGlobalDailyList(systemNote)
      return response.data;
    }
    catch (err: any) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue({ status: err.response.status, code: err.code, message: err.message })
    }
  }
)

export const setViewTypeAndData = createAsyncThunk(`${ACTION_TYPE_PARENT}/setViewType`,
  async ({ type, data }: any, { rejectWithValue }) => {
    try {
      return { type, data };
    }
    catch (err: any) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue({ status: err.response.status, code: err.code, message: err.message })
    }
  }
)

// check if daily list is posted for the day
export const checkIsDailyListPosted = createAsyncThunk(`${ACTION_TYPE_PARENT}/checkIsDailyListPosted`,
  async (_, { rejectWithValue }) => {
    try {
      const response = await getIsDailyListPosted()
      return response.data;
    }
    catch (err: any) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue({ status: err.response.status, code: err.code, message: err.message })
    }
  }
)

// search daily list from DL download page
export const searchDailyList = createAsyncThunk(`${ACTION_TYPE_PARENT}/searchDailyList`,
  async ({ payload, requestHeaders, queryParams }: any, { rejectWithValue }) => {
    try {
      const response = await postSearchDailyList(payload, requestHeaders, queryParams)
      return response;
    }
    catch (err: any) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue({ status: err.response.status, code: err.code, message: JSON.stringify(err.response.data) })
    }
  }
)

// returns instrument document paginated data
export const fetchInstrumentDocData = createAsyncThunk(`${ACTION_TYPE_PARENT}/fetchInstrumentDocData`,
  async ({ pageIndex, pageSize, payload, params, requestHeaders = undefined }: any, { rejectWithValue }) => {
    try {
      const response = await getInstrumentDocumentPaginatedData(pageIndex, pageSize, payload, params, requestHeaders)
      return response;
    }
    catch (err: any) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue({
        status: err.response.status,
        code: err.code,
        message: err.response.data?.title,
        data: err.response.data
      })
    }
  }
)

// fetch daily list download documents
export const fetchDailyListDownload = createAsyncThunk(`${ACTION_TYPE_PARENT}/fetchDailyListDownload`,
  async ({ advanced, requestHeaders = undefined }: any, { rejectWithValue }) => {
    try {
      const response = await getDailyListDocuments(advanced, requestHeaders)
      return response.data;
    }
    catch (err: any) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue({
        status: err.response.status,
        code: err.code,
        message: err.response.data?.title ?? err.response.data,
        data: err.response.data
      })
    }
  }
)

//* get count of instruments pending approval with effective date as NBD
export const fetchInstrumentsPendingApprovalCount = createAsyncThunk(`${ACTION_TYPE_PARENT}/fetchInstrumentsPendingApprovalCount`,
  async (_, { rejectWithValue }) => {
    try {
      const response = await getInstrumentsPendingApprovalCount()
      return response.data;
    }
    catch (err: any) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue({
        status: err.response.status,
        code: err.code,
        message: err.response.data?.title ?? err.response.data,
        data: err.response.data
      })
    }
  }
)

//* get instruments pending approval with effective date as NBD
export const fetchInstrumentsPendingApproval = createAsyncThunk(`${ACTION_TYPE_PARENT}/fetchInstrumentsPendingApproval`,
  async (_, { rejectWithValue }) => {
    try {
      const response = await getInstrumentsPendingApproval()
      return response.data;
    }
    catch (err: any) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue({
        status: err.response.status,
        code: err.code,
        message: err.response.data?.title ?? err.response.data,
        data: err.response.data
      })
    }
  }
)